
import { motion } from "framer-motion";
import { useAtom } from 'jotai';
import { useSecondFilter } from '../../../../data/GlobalStates';

const SubFilterButton = ({speciality}) => {

   const [ SecondFilter, setSecondFilter ] = useAtom(useSecondFilter);

   const updateSecondFilter = (speciality) => {
      setSecondFilter(`${speciality}`)
   };
  
        return (
           <motion.div whileTap={{ scale: 1.1 }}>
              {speciality !== 'Wybierz' ?
                 <div className={SecondFilter === speciality ? 'SubFilterIconFilled' : 'SubFilterIcon'} onClick={() => updateSecondFilter(speciality)}>{speciality}</div>
               : ''}
           </motion.div>
          )
}

export default SubFilterButton;